import { requireService, ScopeDIProvider, wrap } from '@repo/di-ez';
import { Loader } from '@repo/go-ui';
import { clsx } from 'clsx';
import { useCallback, useEffect, useState } from 'react';

import { useStore } from 'src/store';

import { ControlBar, WellsTable } from './features';
import styles from './wells-page.module.scss';
import { WellsPageStore } from './wells-page.store';

export const WellsPage = wrap(function WellsPage() {
  const { notifications, rolesStore, planVersionsService } = useStore();
  const wellsService = requireService('wellsService');
  const [store] = useState(() => new WellsPageStore(notifications, rolesStore, planVersionsService));

  const init = useCallback(() => {
    return {
      wellsPageStore: store,
    };
  }, [store]);

  useEffect(() => {
    store.init();
    const wellsServiceDisposer = wellsService.init();

    return () => {
      wellsServiceDisposer();
    };
  }, [store, wellsService]);

  return (
    <ScopeDIProvider init={init}>
      <div className={clsx(styles.mainContentWrapper)}>
        <ControlBar />
        <div className={styles.tableContainer}>
          {wellsService.isInitializedData && !wellsService.isWellsFetching ? <WellsTable /> : <Loader />}
        </div>
      </div>
    </ScopeDIProvider>
  );
});

declare module '@repo/di-ez' {
  interface ServicesCollectionMap {
    wellsPageStore: WellsPageStore;
  }
}
